module.exports = __webpack_public_path__ + "img/bing.2976afab.png";